var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgLogoApple = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currenColor",
  d: "M36.1 31.2c-.6 1.4-1.3 2.7-2.2 3.9-1.1 1.6-2.1 2.7-2.8 3.3-1.1 1-2.3 1.5-3.6 1.6-.9 0-2-.3-3.3-.8-1.3-.5-2.5-.8-3.5-.8-1.1 0-2.3.3-3.6.8-1.2.5-2.3.8-3.1.8-1.2.1-2.4-.5-3.6-1.6-.8-.7-1.7-1.8-2.9-3.5s-2.3-3.8-3.1-6.1c-.9-2.5-1.3-4.9-1.3-7.3 0-2.7.6-5 1.7-6.9 1-1.5 2.2-2.7 3.7-3.6s3.2-1.4 4.9-1.4c1 0 2.2.3 3.8.9 1.6.6 2.6.9 3 .9.3 0 1.5-.3 3.4-1 1.8-.6 3.3-.9 4.6-.8 3.4.3 5.9 1.6 7.6 4-3 1.8-4.5 4.4-4.5 7.7 0 2.6 1 4.7 2.8 6.4.8.8 1.7 1.4 2.8 1.8-.3.5-.5 1.1-.8 1.7zM28.4.8c0 2-.7 3.9-2.2 5.6-1.8 2.1-3.9 3.2-6.2 3.1v-.8c0-1.9.8-4 2.3-5.7.7-.9 1.7-1.6 2.8-2.1 1.1-.6 2.2-.9 3.2-.9.1.3.1.5.1.8z"
})));

export default SvgLogoApple;